var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import { Icon } from '../Icon';
import { TooltipWrapper } from '../Tooltip';
/**
 * 圆角 Icon/Button
 */
export const ButtonIcon = (_a) => {
    var { icon, iconColor, onClick, type = 'default', size = 'default', borderRadius = '4px', style, className, onMouseEnter, onMouseLeave, disabled = false, tooltip } = _a, props = __rest(_a, ["icon", "iconColor", "onClick", "type", "size", "borderRadius", "style", "className", "onMouseEnter", "onMouseLeave", "disabled", "tooltip"]);
    return (_jsx(TooltipWrapper, Object.assign({ tooltip: tooltip }, { children: _jsx(IconStyled, Object.assign({ color: iconColor, disabled: disabled, _size: size, type: type, radius: borderRadius, icon: icon, onClick: (e) => {
                if (!disabled)
                    onClick === null || onClick === void 0 ? void 0 : onClick(e);
            }, style: style, className: className, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, props), void 0) }), void 0));
};
const IconStyled = styled(Icon) `
  &&& {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s;
    flex-shrink: 0;

    ${props => {
    if (props._size === 'small') {
        return css `
          width: 20px;
          height: 20px;
          font-size: 12px;
        `;
    }
    return css `
        width: 28px;
        height: 28px;
        font-size: 14px;
      `;
}};
    ${props => {
    if (props.type === 'gray') {
        return css `
          color: ${props.theme.text._3};
          background-color: ${props.disabled ? '#f0f1f5' : '#f6f8fA'};
        `;
    }
    return css `
        color: ${props.disabled ? props.theme.text._4 : props.theme.text._3};
        background-color: transparent;
        &:hover {
          background-color: ${props.disabled
        ? 'transparent'
        : props.theme.background._3};
        }
      `;
}};
    border-radius: ${props => props.radius};
    cursor: ${props => {
    if (props.disabled)
        return 'not-allowed';
    return props.onClick ? 'pointer' : 'default';
}};

    ${({ disabled, type, onClick }) => !disabled && type === 'gray' && onClick
    ? css `
            &:hover {
              background-color: #edeff2;
            }
          `
    : ''};
  }
`;
//# sourceMappingURL=data:application/json;base64,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